"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _icons = _interopRequireDefault(require("./icons/"));

var _Module = require("../../Module");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    "& + $root": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    }
  },
  main: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  body: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "100%",
    flexBasis: "100%",
    overflow: "hidden",
    zIndex: 1,
    margin: theme.spacing(1)
  },
  icon: {
    display: "flex",
    margin: theme.spacing(1.5)
  },
  content: {
    width: "100%",
    maxWidth: "100%",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  header: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start"
  },
  footer: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "100%",
    flexBasis: "100%",
    overflow: "hidden",
    zIndex: 1,
    marginLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  linkIcon: {
    fontSize: "18px",
    color: theme.palette.text.secondary
  },
  linkContent: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    fontSize: "14px",
    lineHeight: "24px",
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  linkTitle: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold"
  },
  linkId: {
    fontFamily: "Akkurat Mono, monospace",
    color: theme.palette.text.secondary
  }
}));

const PrimusModuleIcon = ({
  className,
  documentType,
  priorityId = 1,
  conditionId
}) => {
  let PrimusIcon;

  if (priorityId) {
    PrimusIcon = _icons.default['priority' + priorityId];
  } else if (documentType === "damage") {
    PrimusIcon = _icons.default['priority1'];
  }

  if (conditionId && _icons.default[conditionId]) {
    PrimusIcon = _icons.default[conditionId];
  } else if (documentType === "condition") {
    PrimusIcon = _icons.default['tk0'];
  }

  if (documentType === "task") {
    return _react.default.createElement(_Icon.default, {
      className: className
    }, "check");
  }

  if (documentType === "work") {
    return _react.default.createElement(_Icon.default, {
      className: className
    }, "build");
  }

  if (!PrimusIcon) {
    return false;
  }

  return _react.default.createElement(PrimusIcon, {
    className: className
  });
};

const PrimusModuleLink = ({
  linkTitle,
  linkId
}) => {
  const classes = useStyles();

  if (!linkTitle || !linkId) {
    return false;
  }

  return _react.default.createElement("aside", {
    className: classes.link
  }, _react.default.createElement(_Link.default, {
    className: classes.linkIcon
  }), _react.default.createElement(_Typography.default, {
    className: classes.linkContent
  }, _react.default.createElement("b", {
    className: classes.linkTitle
  }, linkTitle), _react.default.createElement("i", {
    className: classes.linkId
  }, linkId)));
};

const PrimusModuleList = (_ref) => {
  let title = _ref.title,
      description = _ref.description,
      label = _ref.label,
      datetime = _ref.datetime,
      onClick = _ref.onClick,
      onEdit = _ref.onEdit,
      onRemove = _ref.onRemove,
      onDelete = _ref.onDelete,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "description", "label", "datetime", "onClick", "onEdit", "onRemove", "onDelete"]);

  const classes = useStyles();
  return _react.default.createElement(_Module.ModuleBase, _extends({}, props, {
    className: classes.root,
    elevation: 1,
    onClick: onClick
  }), _react.default.createElement("div", {
    className: classes.main
  }, _react.default.createElement("div", {
    className: classes.body
  }, _react.default.createElement(PrimusModuleIcon, _extends({}, props, {
    className: classes.icon
  })), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_Module.ModuleTitle, {
    title: title,
    onClick: !onClick && onEdit
  })), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement(_Module.ModuleLabel, {
    label: label
  }), _react.default.createElement(_Module.ModuleDescription, {
    description: description
  }), _react.default.createElement(_Module.ModuleDate, {
    datetime: datetime,
    format: "LL"
  })))), _react.default.createElement(_Module.ModuleActionbar, _extends({}, props, {
    onEdit: onEdit,
    onRemove: onRemove,
    onDelete: onDelete
  }))), _react.default.createElement(PrimusModuleLink, props));
};

PrimusModuleList.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  label: _propTypes.default.string,
  datetime: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onEdit: _propTypes.default.func
} : {};
var _default = PrimusModuleList;
exports.default = _default;
module.exports = exports.default;